export const PREFERRED_ORIGIN_GATEWAYS = [
  { id: 'LAX', lat: 33.942501, lng: -118.407997 },
  { id: 'SFO', lat: 37.61899948, lng: -122.375 },
  { id: 'ORD', lat: 41.9786, lng: -87.9048 },
  { id: 'EWR', lat: 40.692501, lng: -74.168701 },
  { id: 'BWI', lat: 39.1754, lng: -76.668297 },
  { id: 'JFK', lat: 40.639801, lng: -73.7789 },
  { id: 'BOS', lat: 42.3643, lng: -71.005203 },
  { id: 'IAD', lat: 38.9445, lng: -77.455803 },
  { id: 'PHL', lat: 39.87189865, lng: -75.2410965 },
  { id: 'PIT', lat: 40.49150085, lng: -80.23290253 },
  { id: 'ATL', lat: 33.6367, lng: -84.428101 },
  { id: 'MIA', lat: 25.79319954, lng: -80.29060364 },
  { id: 'SEA', lat: 47.449001, lng: -122.308998 },
  { id: 'PHX', lat: 33.435302, lng: -112.005905 },
  { id: 'DTW', lat: 42.21239853, lng: -83.35340118 },
  { id: 'IAH', lat: 29.9843998, lng: -95.34140015 },
  { id: 'DFW', lat: 32.896801, lng: -97.038002 },
  { id: 'CVG', lat: 39.048801, lng: -84.667801 },
  { id: 'SDF', lat: 38.1744, lng: -85.736 },
  { id: 'DEN', lat: 39.86169815, lng: -104.6729965 },
  { id: 'CLE', lat: 41.4117012, lng: -81.84980011 },
  { id: 'SLC', lat: 40.785749, lng: -111.979746 },
  { id: 'PDX', lat: 45.58869934, lng: -122.5979996 },
  { id: 'MCO', lat: 28.42939949, lng: -81.30899811 },
  { id: 'MCI', lat: 39.2976, lng: -94.713898 },
  { id: 'MSP', lat: 44.882, lng: -93.221802 },
  { id: 'OAK', lat: 37.721298, lng: -122.221001 },
];

// Determines what a gateway is in the request form + the order for it to be shown.
// People hate change, hence this order
export const GATEWAYS = [
  'IAD',
  'JFK',
  'LAX',
  'SFO',
  'ORD',
  'IAH',
  'DFW',
  'CVG',
  'SEA',
  'MIA',
  'ATL',

  'LHR',
  'ICN',
  'HKG',
  'CGK',
  'PVG',
  'FRA',
  'TPE',
  'DXB',
];
